import { useContext, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/outline";
import { WorkflowContext } from "../contexts";
import { AutomationMode } from "../interfaces";
import ToggleButton from "./ToggleButton";
import WorkflowAutomationPanelManual from "./WorkflowAutomationPanelManual";
import SmallTextInputField from "./SmallTextInputField";
import SmallSelectField from "./SmallSelectField";
import { convertToRange } from "../utils";
import { useTranslation } from "react-i18next";
import WorkflowAutomationPanelIncomplete from "./WorkflowAutomationPanelIncomplete";

function WorkflowAutomationPanelForms() {
  const { t } = useTranslation();
  const { workflow, automationOptions, updateAutoCreate, updateAutomationOptions } = useContext(WorkflowContext);

  const [automationIsActive, setAutomationIsActive] = useState(false);
  const [showAutoCreate, setShowAutoCreate] = useState(false);

  function handleChangeRange(value: string) {
    updateAutomationOptions({ range: convertToRange(value) });
  }

  return (
    <>
      <div className="flex flex-col gap-2 select-none">
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between text-sm w-full gap-2">
            <div className="flex-shrink-0">{t("Run workflow for")}</div>
            <SmallSelectField value={automationOptions.mode ?? "ALL"} onChange={(mode) => updateAutomationOptions({ mode: mode as AutomationMode })} className="w-full" disabled={automationIsActive}>
              <option value="ALL">{t("all data")}</option>
              <option value="CUSTOM">{t("custom range")}</option>
            </SmallSelectField>
          </div>
          {(automationOptions.mode === "CUSTOM") &&
            <div className="flex text-sm w-full items-center justify-between">
              <SmallTextInputField label={t("Response Range")} className="w-full" placeholder="e.g. 1-5, 8, 10+" value={automationOptions.range ?? ""} onChange={handleChangeRange} autoFocus invalid={!automationOptions.range} disabled={automationIsActive} />
            </div>
          }
          <WorkflowAutomationPanelManual disabled={automationOptions.mode === "CUSTOM" && !automationOptions.range} setIsActive={setAutomationIsActive} />
        </div>
      </div>

      <WorkflowAutomationPanelIncomplete />

      <div className="h-px bg-gray-200 my-4" />

      {/* Auto-Create Section */}
      <div className="flex flex-col gap-2">
        <button className="flex items-center justify-between w-full font-gilroy font-semibold text-sm text-gray-600 cursor-pointer" onClick={() => setShowAutoCreate(b => !b)}>
          <div className="flex items-center gap-2">
            {t("Auto-Create")}
            {workflow.autoCreate && <span className="text-xs text-green font-semibold">{t("Enabled")}</span>}
          </div>
          <ChevronDownIcon className={`w-4 h-4 transition-transform ${showAutoCreate ? "rotate-180" : ""}`} />
        </button>
        {showAutoCreate &&
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2 text-xs text-gray-600">
              <ToggleButton value={workflow.autoCreate} onChange={updateAutoCreate} bgColor="bg-green" />
              <span>{t("Portant will run this workflow whenever a new response is submitted to the form.")}</span>
            </div>
          </div>
        }
      </div>
    </>
  );

}

export default WorkflowAutomationPanelForms;
